export const getPercent = (current?: number, maximum?: number): number => {
  if (maximum === 0) return 100;
  if (!maximum || !current) return 0;
  return Math.round((current / maximum) * 100);
};

export const toNumberOrUndefined = (value?: string | number): number | undefined => {
  if (typeof value === 'number') {
    return isNaN(value) ? undefined : value;
  }

  if (typeof value === 'string') {
    const parsed = parseInt(value);
    return isNaN(parsed) ? undefined : parsed;
  }

  return undefined;
};

export const tryParseFloatValue = (value: string | number): number | null => {
  const num = typeof value === 'number' ? value : typeof value === 'string' ? parseFloat(value) : NaN;
  return Number.isFinite(num) ? num : null;
};

export const tryParseIntValue = (value: string | number): number | null => {
  const num = typeof value === 'number' ? value : Number.parseInt(value, 10);
  return Number.isInteger(num) ? num : null;
};
